export default "__VITE_ASSET__Ccdv2auX__"